import { ACCESS_TOKEN } from "helpers/constant";

export const request = async (options) => {
  const headers = new Headers({
    "Content-Type": "application/json",
  });

  const token = localStorage.getItem(ACCESS_TOKEN);
  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  const defaults = { headers };
  const config = Object.assign({}, defaults, options);

  try {
    const response = await fetch(config.url, config);
    const data = await response.json().catch(() => {
      throw new Error("Invalid JSON response");
    });

    if (!response.ok) {
      const error = new Error(data.error || "Request failed");
      error.status = response.status;
      error.data = data;
      throw error;
    }

    return data;
  } catch (error) {
    console.error(`[API Error] ${error.status || ""}`, error);
    throw error;
  }
};
